import React, {Component} from 'react';
import { Button, Container, Row, Col, FormControl, FormLabel, Alert } from 'react-bootstrap';
import UserService from "./services/auth.service";
import { Navigate } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import { IoIosArrowBack } from "react-icons/io";
import ExportSidebar from './ProSideBar';
import Sidebar from './Sidebar';
import NoPrivileges from './NoPrivileges';

var newDate = new Date()
var gtDate = newDate.getDate().toString().padStart(2,'0') + '-' + (newDate.getMonth()+1).toString().padStart(2,'0') + '-' + newDate.getFullYear()

const NewUserAuth = () => {
  const { user: currentUser } = useSelector((state) => state.auth) 
  // Admin role is id = 3
  // Superadmin role is id = 4
  return (
    (currentUser.roles.includes(4))?(<NewUser />):
    <>
      <NoPrivileges currentUser={currentUser}/>
    </>
  )
}

class NewUser extends Component {  

  constructor(props) {
    super(props);
    this.onChangeUsername = this.onChangeUsername.bind(this);
    this.onChangeUserFirstname = this.onChangeUserFirstname.bind(this);
    this.onChangeUserLastname = this.onChangeUserLastname.bind(this);
    this.onChangeEmail = this.onChangeEmail.bind(this);
    this.saveUser = this.saveUser.bind(this);
    this.handleValidations = this.handleValidations.bind(this);
    this.onChangeEmployeeNumber = this.onChangeEmployeeNumber.bind(this);

    this.state = {
      id: null,
      matricula: "",
      primernombre: "",
      segundonombre: "",
      primerapellido: "",
      segundoapellido: "",
      email: "",
      fechadenacimiento: "",
      curp: "",
      telefonomovil: "",
      salariodiarioesperado: "",
      banco: "",
      arean1: "",
      arean2:"",
      //usuario: "", campo calculado
      bio: "",
      password: "password",
      roles: [1],
      showerror: false,
      errmessage:'',   
      showsuccess: false,
      succmessage: ''
    };
  }

  goToUserList() {
    window.location.assign('/admin-users');
  }

  handleValidations() {
    if (this.state.employeenumber.length==0 || this.state.username.length==0 || this.state.roles.length==0 || this.state.password.length==0 ) {
      this.setState({errmessage:'Employee number, username, password and roles can not be empty.'})
      this.setState({showerror:true})
      return;
    }
    if (this.state.email) {
      if (!/\S+@\S+\.\S+/.test(this.state.email)) {
        this.setState({errmessage:'Email is invalid.'})
        this.setState({showerror:true})
        return;
      }
    }
    this.saveUser();
  } 

  onChangeEmployeeNumber(e) {
    this.setState({
      matricula: e.target.value
    });
  }

  onChangeUserFirstname(e) {
    this.setState({
      userfirstname: e.target.value
    });
  }

  onChangeUserLastname(e) {
    this.setState({
      userlastname: e.target.value
    });
  }

  onChangeUsername(e) {
    this.setState({
      username: e.target.value
    });
  }

  onChangeEmail(e) {
    this.setState({
      email: e.target.value
    });
  }

  saveUser() {
    var pw = Math.random().toString(36).substr(2, 8);
    UserService.register(this.state.employeenumber, this.state.userfirstname, this.state.userlastname, this.state.username, this.state.email, pw, this.state.roles)        
      .then(response => {
        this.setState({
          password: pw,
          submitted: true
        });
        this.setState({errmessage:''})
        this.setState({showerror:false})
        this.setState({succmessage:response.data.message})
        this.setState({showsuccess:true})            
      })
      .catch(e => {
        this.setState({errmessage:e.response?e.response.data.message:e.message})       
        this.setState({showerror:true})
        this.setState({succmessage:''})
        this.setState({showsuccess:false})          
      });
  }

  render() {
    return (
      <>
      <Sidebar />
      <div style={{display:'flex', flexDirection:'row', gap:'10px'}}>

        <ExportSidebar />

        <Container>
          <Row className='mb-2'>
            <FormLabel style={{fontSize:"0.8em",textAlign:"right"}}>Fecha de hoy: {gtDate}</FormLabel>
            <hr/>
            <h3 className='mb-4' style={{width: "100%", textAlign: "center", marginLeft: "0%", color: "green" }}>Nuevo usuario</h3>
            <Col className='col-md-3'>
              <FormLabel className='mb-2'>Matrícula:</FormLabel>       
              <FormControl style={{maxWidth:"300px"}} type="text" name="matricula" id="matricula" onChange={this.onChangeEmployeeNumber}></FormControl>
            </Col>          
            <Col className='col-md-3'>
              <FormLabel className='mb-2'>User Firstname:</FormLabel>       
              <FormControl style={{maxWidth:"300px"}} type="text" name="userfirstname" id="userfirstname" onChange={this.onChangeUserFirstname}></FormControl>
            </Col>
            <Col className='col-md-3'>
              <FormLabel className='mb-2'>User Firstname:</FormLabel>       
              <FormControl style={{maxWidth:"300px"}} type="text" name="userfirstname" id="userfirstname" onChange={this.onChangeUserFirstname}></FormControl>
            </Col>
            <Col className='col-md-3'>
              <FormLabel className='mb-2'>User Lastname:</FormLabel>       
              <FormControl style={{maxWidth:"300px"}} type="text" name="userlastname" id="userlastname" onChange={this.onChangeUserLastname}></FormControl>
            </Col>
            <Col className='col-md-3'>
              <FormLabel className='mb-2'>Username:</FormLabel>       
              <FormControl style={{maxWidth:"300px"}} type="text" name="username" id="username" onChange={this.onChangeUsername}></FormControl>
            </Col>

            <Col className='col-md-3'>
              <FormLabel className='mb-2'>Email:</FormLabel>       
              <FormControl style={{maxWidth:"300px"}} type="text" name="email" id="email" onChange={this.onChangeEmail}></FormControl>
            </Col>          

          </Row>
          <Row>
              
          </Row>
          <Row>
              <Col className='mt-4'>                                
                  <FormLabel className='mb-2'>Password</FormLabel>       
                  <FormControl style={{maxWidth:"300px"}} value={this.state.password} type="text" name="password" id="password" disabled onChange={this.onChangePassword}></FormControl>
                  <div className='mb-2'>Password will be generated when user is saved. Please, share this information with the user. You can always restore the password if needed.</div>       
              </Col>  
          </Row>
          <hr/>
          <Row className='mb-2'>
            <Col className='col-md-3'>
              <Button className='m-2' id='saveUser' onClick={this.handleValidations}>Save User</Button>            
              <Button className='m-2' id='backToUsersList' onClick={this.goToUserList}><IoIosArrowBack/></Button>            
            </Col>
          </Row>  
          {this.state.showerror && (
            <Alert variant="danger" onClose={() => this.setState({showerror:false})} dismissible>
              <Alert.Heading>Error</Alert.Heading>
              <p>{this.state.errmessage}</p>
            </Alert>      
          )}
          {this.state.showsuccess && (
            <Alert variant="success" onClose={() => this.setState({showsuccess:false})} dismissible>
              <Alert.Heading>Done</Alert.Heading>
              <p>{this.state.succmessage}</p>
            </Alert>      
          )}     
        </Container>
      </div>
      </>
    )      
  }
}

export default NewUserAuth;